module.exports = __webpack_public_path__ + "img/Location.d046d1c2.svg";